var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body-item"},[(_vm.useBlankIcon)?_c('div',{class:_vm.iconClass}):_c('div',[_c('svgicon',{class:_vm.iconClass,attrs:{"icon":`ks-icon-${_vm.icon}`}})],1),_vm._v(" "),_c('div',{staticClass:"card-body-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }